import { LitElement, html, property } from 'lit-element'
import contextMenuStyles from './context-menu.styles.scss'
import { repeat } from 'lit-html/directives/repeat'
import type { ContextMenu } from './models'
import { unsafeSVG } from 'lit-html/directives/unsafe-svg'
import { nothing } from 'lit-html'
import { t } from '../../directives/translate'
import { navigateToUrl } from '../../common/helpers'
import { openNewTabFor } from '../../common/dom-helpers'
import { ifDefined } from 'lit-html/directives/if-defined'

export class GoToContextMenu extends LitElement {
  static readonly tagName = 'goto-context-menu'

  @property({ type: Array })
  menuItems: readonly ContextMenu[] = []

  static get styles() {
    return contextMenuStyles
  }

  private renderMenuItem({ text, href, icon, isExternalLink, dataTest }: ContextMenu) {
    return html`
      <chameleon-menu-item
        @click=${() => (isExternalLink ? openNewTabFor(href) : navigateToUrl(href))}
        aria-label=${text}
        data-test=${ifDefined(dataTest)}
      >
        ${icon ? html`<chameleon-svg slot="leading-icon">${unsafeSVG(icon)}</chameleon-svg>` : nothing} ${text}
      </chameleon-menu-item>
    `
  }

  render() {
    return html`
      <nav>
        <chameleon-menu label=${t('GoTo menu')}>
          ${repeat(this.menuItems, menuItem => menuItem.href, this.renderMenuItem)}
        </chameleon-menu>
      </nav>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GoToContextMenu.tagName]: GoToContextMenu
  }
}
